// Iter-46an: shared activity-name formatter so badges display in
// Title Case ("Yoga", "Reformer Pilates") regardless of how the activity
// was stored. Handles common acronyms (HIIT, TRX, EMS, etc.) and the
// "general" sentinel value used by class-pass / studio defaults.

const ACRONYMS = new Set([
  'hiit',
  'trx',
  'ems',
  'pt',
  'amrap',
  'crossfit',
  'wod',
]);

/**
 * Format an activity_type / activity_name for display.
 * - null/undefined/empty → ''
 * - "general" → "General"
 * - "reformer pilates" → "Reformer Pilates"
 * - "hiit" → "HIIT"
 *
 * Already-title-cased strings are returned untouched.
 *
 * @param {string|null|undefined} value
 * @returns {string}
 */
export function formatActivity(value) {
  if (!value || typeof value !== 'string') return '';
  return value
    .trim()
    .split(/\s+/)
    .map((word) => {
      const lower = word.toLowerCase();
      if (ACRONYMS.has(lower)) return lower.toUpperCase();
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    })
    .join(' ');
}
